import { useMemo } from 'react';
import { type VehicleCycledEnergyRecord } from '../services/battery-monitoring-api/types/battery-monitoring-api';
import { type SelectedChartSegment } from '@/app/config/chart-segments';

interface UseFilteredVehiclesParameters {
  baseFilteredVehicles?: VehicleCycledEnergyRecord[];
  selectedStateOfHealthSegment: SelectedChartSegment | null;
  selectedCycledEnergySegment: SelectedChartSegment | null;
}

const useSegmentFilteredVehicles = ({
  baseFilteredVehicles,
  selectedStateOfHealthSegment,
  selectedCycledEnergySegment,
}: UseFilteredVehiclesParameters): VehicleCycledEnergyRecord[] | undefined => {
  return useMemo(() => {
    if (!baseFilteredVehicles) return;

    return baseFilteredVehicles.filter((vehicle) => {
      const segments: SelectedChartSegment[] = [];

      if (selectedStateOfHealthSegment) {
        segments.push(selectedStateOfHealthSegment);
      }

      if (selectedCycledEnergySegment) {
        segments.push(selectedCycledEnergySegment);
      }
      return segments.every((segment) => segment.filterVehicle({ vehicle }));
    });
  }, [baseFilteredVehicles, selectedStateOfHealthSegment, selectedCycledEnergySegment]);
};

export default useSegmentFilteredVehicles;
